import axios from 'axios';

export const recruitmentApi = (method, path, data, params) => axios({
  method, url: `${process.env.REACT_APP_API_HOST}/api/v2${path}`, data, params,
  headers: {Authorization: `Bearer ${localStorage.getItem('userToken')}`, 'App-Network': localStorage.getItem('networkId')},
});

export const recruitmentItems = async (path, params = {}) => {
  const items = [];
  let page = 1;
  while (true) {
    const response = await recruitmentApi('get', path, undefined, {...params, item_per_page: 200, page});
    const batch = response.data?.data?.items || [];
    items.push(...batch);
    if (!batch.length || items.length >= (response.data?.data?.total_item_count ?? items.length)) return items;
    page += 1;
  }
};
